import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getStoreListByCountryId = (CountryId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_STORE_LIST_BY_COUNTRY_ID(CountryId)
  );
};

export default getStoreListByCountryId;
